import { PerformanceTier } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';
import { DisplayTier } from './types';
import wingsSilverLeftImg from './assets/wings-silver-left.png';
import wingsSilverRightImg from './assets/wings-silver-right.png';
import wingsGoldLeftImg from './assets/wings-gold-left.png';
import wingsGoldRightImg from './assets/wings-gold-right.png';

export const BOLT_STAR_ROUTE = '/analytics/boltStar';
export const BOLT_STAR_HOW_IT_WORKS_ROUTE = `${BOLT_STAR_ROUTE}/howItWorks`;

/** Length of the performance window a level is calculated from - to be gotten from backend later */
export const BOLT_STAR_EVALUATION_MONTHS = 2;
/** Orders needed within the evaluation window to get a level - to be gotten from backend later */
export const BOLT_STAR_MIN_ORDERS = 30;

/** Performance tiers in the left-to-right order the comparison tables show them. */
export const TIER_ORDER: PerformanceTier[] = [
  PerformanceTier.POOR,
  PerformanceTier.NEEDS_IMPROVEMENT,
  PerformanceTier.GOOD,
  PerformanceTier.TOP,
];

interface TierMeta {
  leftIcon?: string;
  rightIcon?: string;
}

export const TIER_META: Record<DisplayTier, TierMeta> = {
  ineligible: {},
  poor: {},
  needs_improvement: {},
  good: { leftIcon: wingsSilverLeftImg, rightIcon: wingsSilverRightImg },
  top: { leftIcon: wingsGoldLeftImg, rightIcon: wingsGoldRightImg },
};
